exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dropdown-menu-triangle {\n  display: none; }\n  .dropdown-triangle > .dropdown-menu > .dropdown-menu-triangle {\n    display: block; }\n", ""]);

